<template>
  <v-row justify="center" align="center">
    <v-col cols="12">
      <v-banner icon="mdi-format-list-checkbox">
        Templates
        <template v-slot:actions>
          <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
    </v-col>

    <v-col cols="12" v-if="!development">
      <div>This page is currently under development</div>
    </v-col>
    <v-col cols="12" v-else>
      <v-row justify="start" align="start" no-gutters>
        <v-col v-if="loadingTemplates" cols="12" lg="12" xs="12">
          <v-card class="mx-auto" outlined height="100%" loading>
            <v-card-title>Loading Templates...</v-card-title>
            <template slot="progress">
              <v-progress-linear color="blue darken-2" indeterminate></v-progress-linear>
            </template>
          </v-card>
        </v-col>
        <v-col v-else cols="12" lg="12" xs="12">
          <v-card v-if="templates.length == 0" color="background" flat>
            <v-card-title>You currently have no templates</v-card-title>
          </v-card>

          <v-card
            v-else
            class="mb-4"
            outlined
            v-for="template in templates"
            :key="template.id"
            @click="getTemplateProds(template.id)"
          >
            <v-card-title>{{template.name}}</v-card-title>
            <!-- <v-card-actions>
              <v-btn text color="error">Delete</v-btn>
              <v-spacer />
              <v-btn text color="blue darken-2">Select</v-btn>
            </v-card-actions>-->
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  components: {},

  data() {
    return {
      development: true,
      showCreate: false,
      loadingTemplates: false,
      loadingProducts: false
    };
  },

  computed: {
    templates() {
      return this.$store.getters.retrieveAllTemplates;
    },

    trolly() {
      return this.$store.getters.retrieveCurrentTrolly;
    }
  },

  async activated() {
    //When Activated we want to refresh our templates
    this.loadingTemplates = true;
    let templateResponse = await this.getTemplates();

    if (!templateResponse) {
      this.setSnackbar({ color: "error", text: "Error finding templates" });
    }

    this.loadingTemplates = false;
  },

  methods: {
    ...mapActions(["getTemplates", "setSnackbar"]),
    ...mapActions("orderSearch", ["getTemplateProducts"]),

    async getTemplateProds(templateId) {
      this.loadingProducts = true;

      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        orderDate: this.$store.getters.retrieveCurrentTrolly.order_date,
        trollyId: templateId,
        template: true
      });

      await this.getTemplateProducts(stringPayload);

      this.loadingProducts = false;
      this.$router.push({ name: "OrdersSearch" });
    }
  }
};
</script>

<style lang="sass" scoped>
</style>